import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'msc-showroom-exhibit-wave-page',
    templateUrl: './showroom-exhibit-wave-page.component.html',
    styleUrls: ['./showroom-exhibit-wave-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})

export class ShowroomExhibitWavePageComponent {

}
